import { gql } from 'apollo-angular';

export const GET_BANK_ACCOUNTS = gql`
  query getBankAccounts($search: String) {
    bankAccounts(search: $search) {
      id
      bankName
    }
  }
`;

export const GET_BANK_ACCOUNT_BY_ID = gql`
  query getBankAccountById($id: Int!) {
    bankAccount(id: $id) {
      id
      bankName
    }
  }
`; 